export default "__VITE_ASSET__DuJoUl$b__"